import { createResource } from '@atlassian/react-resource-router';

import { getProjectKeyId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { ViewsResponse } from './types.tsx';

export const fetchViews = (workspaceId: string, projectKey: string): Promise<ViewsResponse> =>
	performGetRequest<ViewsResponse>(
		`/gateway/api/jsm/reporting/jira/workspace/${workspaceId}/project/${projectKey}/views`,
	);

export const SUMMARY_PAGE_VIEWS_RESOURCE_KEY = 'SERVICE_DESK_PROJECT_SUMMARY_VIEWS';

export const summaryPageViewsResource = createResource<ViewsResponse>({
	type: SUMMARY_PAGE_VIEWS_RESOURCE_KEY,
	getKey: ({ match, query }) => {
		const { projectKey } = getProjectKeyId(match, query);
		return `${SUMMARY_PAGE_VIEWS_RESOURCE_KEY}_${projectKey}`;
	},
	getData: async ({ match, query }, { tenantContext: { activationId: workspaceId } }) => {
		const { projectKey } = getProjectKeyId(match, query);

		return fetchViews(workspaceId, projectKey);
	},
});
